import styled from "styled-components";
import Image from "../../../../../../../base/multimedia/image/index.js";
import { InnerMarkdownHTML } from "../../../../../../../base/text/inner-markdown-HTML/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../../styles/common/mixins/logical.styled.js";
export const ProductContainer = styled.a.withConfig({
    displayName: "styled__ProductContainer",
    componentId: "sc-4bb2fd28-0"
})`
	${FlexMixin({
    align: 'center'
})}
	width: calc(${({ $hasBanner  })=>$hasBanner ? '50%' : '33.33%'} - 20px);
	margin: 0 10px 20px;

	@media (max-width: ${(props)=>props.theme.breakpoints.xl}px) {
		width: calc(50% - 20px);
	}
`;
export const ProductImage = styled(Image).withConfig({
    displayName: "styled__ProductImage",
    componentId: "sc-4bb2fd28-1"
})`
	${BorderRadius({
    all: '50%'
})}
	overflow: hidden;
	margin-right: 16px;
	min-width: 90px;

	@media (max-width: ${(props)=>props.theme.breakpoints.xxl}px) {
		display: none;
	}

	@media (max-width: ${(props)=>props.theme.breakpoints.xl}px) {
		display: block;
	}

	@media (max-width: ${(props)=>props.theme.breakpoints.lg}px) {
		display: none;
	}
`;
export const ProductMain = styled.div.withConfig({
    displayName: "styled__ProductMain",
    componentId: "sc-4bb2fd28-2"
})`
	${FlexMixin({
    direction: 'column'
})}
`;
export const ProductTitle = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductTitle",
    componentId: "sc-4bb2fd28-3"
})`
	${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'large'
})}
	color: ${({ theme  })=>theme.colors.grays.darker};
	margin-bottom: 4px;
`;
export const ProductDesc = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductDesc",
    componentId: "sc-4bb2fd28-4"
})`
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'base'
})}
	color: ${({ theme  })=>theme.colors.grays.darker};
`;
export const ProductInfo = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__ProductInfo",
    componentId: "sc-4bb2fd28-5"
})`
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin-top: 2px;
`;
export const ProductAside = styled.div.withConfig({
    displayName: "styled__ProductAside",
    componentId: "sc-4bb2fd28-6"
})`
	${FlexMixin({
    direction: 'column',
    align: 'center'
})}
	margin-left: auto;
	padding-left: 16px;
`;
export const ProductPrice = styled.span.withConfig({
    displayName: "styled__ProductPrice",
    componentId: "sc-4bb2fd28-7"
})`
	${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'base'
})}
	color: ${({ theme  })=>theme.colors.secondary.base};
`;
export const ProductPerPerson = styled.span.withConfig({
    displayName: "styled__ProductPerPerson",
    componentId: "sc-4bb2fd28-8"
})`
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.secondary.base};
	margin-bottom: 8px;
`;
export const ProductLink = styled.span.withConfig({
    displayName: "styled__ProductLink",
    componentId: "sc-4bb2fd28-9"
})`
	${BorderRadius({
    all: '4px'
})}
	${FontMixin({
    size: 'small',
    weight: 'medium',
    height: 'small'
})}
	background-color: ${({ theme  })=>theme.colors.secondary.base};
	color: ${({ theme  })=>theme.colors.white.base};
	padding: 10px 12px 9px;
	text-transform: uppercase;
	white-space: nowrap;
`;

//# sourceMappingURL=styled.js.map